<template>
  <div
    v-if="geoType === 'precinct'"
    class="topline-top-info">
    Precinct level results may not match countywide results due to the process of collection
  </div>
</template>

<script>
const props = ["geoType"];

export default {
  props,
};
</script>

<style>
.topline-top-info {
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  opacity: 0.6;
  text-align: center;
}
</style>
